import React from 'react';
import { Tooltip, Button } from '@douyinfe/semi-ui';
import { IconBellStroked } from '@douyinfe/semi-icons';

class NotificationButton extends React.Component {
  render() {
    return (
      <Tooltip content="Уведомления" position="bottom">
        <Button
          icon={<IconBellStroked />}
          style={{
            position: 'absolute',
            top: '10px',
            right: '25px',
            zIndex: 1000,
          }}
        />
      </Tooltip>
    );
  }
}

export default NotificationButton;